import Vue from 'vue'
import Vuex from 'vuex'
import global from './modules/global'
import category from './modules/category'
import project from './modules/project'
import product from './modules/product'
import news from './modules/news'
import activity from './modules/activity'
import myuser from './modules/my'
import home from './modules/home'

Vue.use(Vuex)

const debug = import.meta.env.DEV

export default new Vuex.Store({
    modules: {
        global,
        home,
        category,
        project,
        myuser,
        news,
        activity,
        product
    },
    strict: debug,
    plugins: debug ? [] : []
})

